<template>

    <div>
        <p><a href="#" @click="$router.push('/settings/users')" class="mb-2"><i class="fa-regular fa-angle-left"></i> Back to All Users</a></p>
        <b-card v-if="user != null" body-class="main-card">
            <template v-slot:header>
                <b-form-row>
                    <b-col><span class="h3">User: {{ userCache.name }}</span></b-col>
                    <b-col v-if="isSuperAdmin" class="text-right"><b-button @click="loginAs">Login As</b-button></b-col>
                </b-form-row>

            </template>
            <div class="overlay text-center d-flex justify-content-center align-items-center">
                <h5 class="text-success">Saved <i class="fa-solid fa-circle-check"></i></h5>
            </div>
            <b-form-row>
                <b-col>
                    <label>Users Name</label>
                    <b-form-input v-model="user.name"></b-form-input>
                </b-col>
                <b-col>
                    <label>Password:</label>
                    <b-form-input v-model="newPassword"></b-form-input>
                </b-col>
                <b-col>
                    <label>Email:</label>
                    <b-form-input v-model="user.email"></b-form-input>
                </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
                <b-col class="text-right">
                    <b-button variant="danger"
                              class="mr-2"
                              v-b-modal.modal-delete-user>
                            Delete User
                    </b-button>
                    <b-button variant="warning"
                              class="mr-2"
                              disabled
                              v-b-modal.modal-deactivate-user>
                        Deactivate User
                    </b-button>
                    <b-button @click="updateUser()" variant="success">
                        <span v-if="isSavingUserUpdate">
                            Updating <i  class="fa-regular fa-spin fa-spinner"></i>
                        </span>
                        <span v-else>
                            Update User
                        </span>
                    </b-button>
                </b-col>
            </b-form-row>



            <b-card class="mt-4">
                <template v-slot:header>
                    <b-form-row>
                        <b-col><h4 class="mb-0">Roles/Permissions</h4></b-col>
                    </b-form-row>
                </template>
                <template v-for="roles in user.roles.data">
                    <h5>{{ roles.name }}</h5>
                    <ul class="list-unstyled" :class="roles.permissions.data.length > 10 ? 'split-columns':'' ">
                        <li v-for="permissions in roles.permissions.data">
                            <i class="fa-solid fa-check-circle text-success"></i> {{permissions.name | titleCase}}
                        </li>
                    </ul>
                    <hr>
                </template>


                <template v-slot:footer>
                    <b-button class="float-right"
                              variant="warning"
                              @click="$router.push('/settings/permissions?id=' + user.id  )">
                        Change Roles/Permissions
                    </b-button>
                </template>
            </b-card>
        </b-card>


        <!--user delete confirmation-->
        <b-modal ref="modal-delete-user" id="modal-delete-user" title="Delete User">
            <div class="text-center">
                <p v-if="user != null">Are you sure you want to delete <span class="font-weight-bold">{{ user.name }}</span>?<br>
                    This action is permanent.
                </p>

                <b-button variant="danger"
                          size="lg"
                          class="mt-2"
                          @click="deleteUser()">
                        <span v-if="isDeletingUser">
                            Deleting <i  class="fa-regular fa-spin fa-spinner"></i>
                        </span>
                        <span v-else>
                            Delete User
                        </span>
                </b-button>

            </div>
            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>


        <!--user deleted success modal-->
        <b-modal ref="modal-user-deleted" id="modal-user-deleted" title="Deactive User">
            <div class="text-center">
                <p>User {{ userCache.name }} was deleted. Click OK to go back to Users List</p>

                <b-button variant="success"
                          size="lg"
                          class="mt-2"
                          @click="goToUsersListView()">
                    OK
                </b-button>

            </div>
            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>


        <!--user deactivate confirmation-->
        <b-modal id="modal-deactivate-user" title="Deactive User">
            <div class="text-center">
                <p v-if="user != null">Are you sure you want to deactivate user:
                    <span class="font-weight-bold">{{ user.name }}</span>
                </p>

                <b-button variant="danger"
                          size="lg"
                          class="mt-2"
                          @click="deactivateUser()">
                    Deactivate User
                </b-button>

            </div>
            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {AUTH_LOGINAS, SYNC_USER} from '../../../store/actions';
    export default {
        name: 'settings-user-view',
        data() {
            return {
                isSuperAdmin: false,
                isSavingUserUpdate: false,
                isDeletingUser: false,
                user: null,
                userCache: null,
                permissions: null,
                roles: null,
                roleForUser: null,
                groups: null,
                levels: null,
                newPassword: null,
                isActive: {
                    selected: 0,
                    options: [
                        {value: 0, text: "No"},
                        {value: 1, text: "Yes"},
                    ]
                },
                isStaff: {
                    selected: 0,
                    options: [
                        {value: 0, text: "No"},
                        {value: 1, text: "Yes"},
                    ]
                }
            }
        },
        created() {
            this.getUser();
            this.checkIsSuperAdmin();
//            this.getRoles();
        },
        computed: {
            permissionsLength() {
                if(this.permissions && this.permissions.length > 14) {
                    return 'split-columns'
                }
            }
        },
        methods: {
            getUser() {
                this.$http.get('/users/' + this.$route.params.id).then(response => {
                    this.user = response.data.data
                    this.userCache = JSON.parse(JSON.stringify(this.user));
                }).catch((e)=>{
                    console.log('error: ', e)
                });
            },
            loginAs() {
                this.$store.dispatch(AUTH_LOGINAS, this.user.id).then(() => {
                    this.$store.commit('FORCE_CACHE_BUST');
                    //full page reloaded needed to reset some minor elements
                    window.location.href = window.location.origin + "/dashboard";
                    //vm.$router.push({name: 'home'});
                    //vm.$router.go(0);
                }).catch((err) => {
                    console.log("ERROR", err);
                });
            },
            checkIsSuperAdmin() {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    if (this.$store.getters.getProfile.roles) {
                        let userRoles = this.$store.getters.getProfile.roles.data;
                        this.isSuperAdmin =  _.find(userRoles, (role) => {return role.name == "Super Admin";}) != null;
                    }
                });
            },
            updateUser() {
                this.isSavingUserUpdate = true;
                if(this.newPassword == '') {
                    this.newPassword = null;
                }
                let payload = {
                    name: this.user.name,
                    email: this.user.email,
                    password: this.newPassword,
                };
                this.$http.put('/users/' + this.$route.params.id, payload).then(response => {
                        this.user.name = response.data.data.name;
                        this.user.email = response.data.data.email;
                        this.userCache = JSON.parse(JSON.stringify(this.user));
                        this.isSavingUserUpdate = false;
                    }).catch((e)=>{
                        console.log('error: ', e);
                        this.isSavingUserUpdate = false;
                        this.user = JSON.parse(JSON.stringify(this.userCache));
                        alert('Error in updating users information.');
                });

            },
            deleteUser() {
                this.isDeletingUser = true;
                this.$http.delete('/users/' + this.$route.params.id).then(response => {
                        this.$refs['modal-delete-user'].hide();
                        this.$refs['modal-user-deleted'].show();
                        this.isDeletingUser = false;
                    }).catch((e)=>{
                        console.log('error: ', e)
                        alert('Error: User not deleted.')
                });
            },
            deactivateUser() {
                alert('Method in production mode.')
            },
            goToUsersListView() {
                let path = '/settings/users';
                this.$router.push({path: path});
            },
        }
    };
</script>

<style scoped>
        [v-cloak] {
            display: none !important;
        }
        .main-card {
            position: relative;
        }
        .overlay {
            position: absolute;
            background: rgba(255,255,255,0.9);
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
        }
        .split-columns {
            columns:3;
        }
</style>
